import { forwardRef, memo } from "react";
import classnames from "classnames";
import { StepBase } from "../../StepBase";
import { ProgressStepProps } from "../types";
import { getIndicatorState } from "../utils";

import styles from "./style.module.scss";

export type ProgressMinimalIconsProps = ProgressStepProps & { text?: boolean, textClassName?: string };

export const ProgressMinimalIcons = memo(
  forwardRef<HTMLDivElement, ProgressMinimalIconsProps>(
    (
      {
        text = true,
        size = "sm",
        className,
        currentStep = 0,
        textClassName,
        ...props
      },
      ref,
    ) => {

      return (
        <div
          className={classnames(
            styles.root,
            className,
            styles[size as keyof typeof styles],
          )}
          {...props}
          ref={ref}
        >
          {
            text && <p className={classnames(styles.text, textClassName)}>{`Step ${currentStep + 1} of ${props.steps.length}`}</p>
          }
          {props.steps.map((item, index) => (
            <StepBase
              {...item}
              id={`${item?.id}`}
              key={item.id}
              size={size}
              status={getIndicatorState(index, currentStep)}
              type={"iconOnly"}
            />
          ))}
        </div>
      );
    },
  ),
);
